import { FC, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import {
  Center,
  Heading,
  VStack,
  Button,
  Box,
  Text,
  Spinner,
  TabList,
  Tab,
  Tabs,
  TabPanels,
  TabPanel,
} from '@chakra-ui/react'
import { useAdminItems } from '@olagg/api-hooks'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { ROUTES } from '../../consts/routes'
import { FaPlus } from 'react-icons/fa'
import { IUseItems } from '@olagg/api-hooks/interfaces/IUseItems'
import Pagination from '@olagg/ui-kit/Pagination'
import ItemsTable from './Table'
import { OlaggModule, PermissionEnum } from '@olagg/db-types'
import useRoles from '../../features/Roles/hooks/useRoles'
import Products from './products'
import OrdersList from './orders'
import PercentageCoupon from './products/components/PercentageCoupon'
import CouponsIndex from './products/CouponsIndex'

const TABS = ['productos', 'ordenes', 'tienda', 'cupones']

const GamesContent: FC = () => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const [filter, setFilter] = useState<IUseItems>({
    title: searchParams.get('title') || undefined,
    page: Number(searchParams.get('page') || 1),
    limit: Number(searchParams.get('limit') || 10)
  })

  const { missingPermission } = useRoles();

  const onFilter = ({
    name,
    value
  }: EventTarget & HTMLInputElement) => {
    setFilter({ ...filter, [name]: value })

    if (value) searchParams.set(name, value)
    else searchParams.delete(name)
    setSearchParams(searchParams)
  }
  const { title, page, limit } = filter
  const { items, count, isLoading } = useAdminItems({
    page, limit, title
  })

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>
          Tienda
        </Heading>

        <Button
          display='flex'
          alignSelf='self-start'
          variant="outlinedGradient"
          leftIcon={<FaPlus />}
          onClick={() => navigate(ROUTES.MARKETPLACE.create)}
          isDisabled={missingPermission(OlaggModule.Item, PermissionEnum.CREATE)}
        >
          Agregar Item
        </Button>

        {isLoading ? (
          <Box height='300px' display='flex' justifyContent='center' alignItems='center' fontWeight='600' flexDirection='column'>
            <Spinner />
          </Box>
        ) : (
          items?.length > 0 ? (
            <ItemsTable items={items} />
          ) : (
            <Box height='300px' display='flex' justifyContent='center' alignItems='center' fontWeight='600' flexDirection='column'>
              <Text>No hay items en la tienda</Text>
            </Box>
          )
        )}
        <Pagination
          params={{ limit, page, count }}
          onClick={page =>
            onFilter({
              name: 'page',
              value: String(page + 1)
            } as EventTarget & HTMLInputElement)
          }
          onLimitChange={val =>
            onFilter({
              name: 'limit',
              value: val
            } as EventTarget & HTMLInputElement)
          }
          hideLimitInput
        />
      </VStack >
    </Center >
  )
}

const MarketplaceTabs = () => {
  const [tabIndex, setTabIndex] = useState<number>(0)
  const { hash } = useLocation();
  const activeTab = hash.search('#') === 0 ? hash : `#${TABS[0]}`;
  const handleTabChange = (index: number) => {
    setTabIndex(index);
    window.location.hash = TABS[index];
  }

  useEffect(() => {
    const index = TABS.findIndex(tab => `#${tab}` === activeTab);
    setTabIndex(index === -1 ? 0 : index);
  }, [hash]);

  return (
    <>
      <Tabs
        index={tabIndex}
        onChange={handleTabChange}
        isLazy
      >
        <TabList
          margin='0 20px 0px 20px'
          borderColor='#343847'
          position='relative'
          sx={{
            '&::-webkit-scrollbar': {
              display: 'none !important'
            },
            overflowX: 'auto !important',
            overflowY: 'hidden !important',
          }}
        >
          <Tab color="white" whiteSpace='nowrap' paddingBottom='4px' _selected={{ fontWeight: '800', borderBottom: '4px solid white', paddingBottom: '2px' }} fontWeight='600'>
            Productos
          </Tab>
          <Tab color="white" whiteSpace='nowrap' paddingBottom='4px' _selected={{ fontWeight: '800', borderBottom: '4px solid white', paddingBottom: '2px' }} fontWeight='600'>
            Ordenes
          </Tab>
          <Tab color="white" whiteSpace='nowrap' paddingBottom='4px' _selected={{ fontWeight: '800', borderBottom: '4px solid white', paddingBottom: '2px' }} fontWeight='600'>
            Tienda
          </Tab>
          <Tab color="white" whiteSpace='nowrap' paddingBottom='4px' _selected={{ fontWeight: '800', borderBottom: '4px solid white', paddingBottom: '2px' }} fontWeight='600'>
            Cupones
          </Tab>
        </TabList>

        <TabPanels p='0'>
          <TabPanel p='0'>
            <Products />
          </TabPanel>
          <TabPanel p='0'>
            <OrdersList />
          </TabPanel>
          <TabPanel p='0'>
            <GamesContent />
          </TabPanel>
          <TabPanel p='0'>
            <CouponsIndex />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  )
}

export default MarketplaceTabs
